
import { Component, Vue, Prop } from 'vue-property-decorator';
// @ts-ignore
import stores from '@/stores';
import session from '@/stores/Session';
import axiosInstance from '../../helpers/axios';
import {SweetModal} from 'sweet-modal-vue';
import { translate } from '@/helpers/functions';

@Component({
  components: {
    SweetModal,
  },
})
export default class CreateEpgSource extends Vue {

  newEpgSource: IEpgProvider = {
    id: null,
    url: '',
    active: true,
    type : 1000
  };

  types : IEpgProviderType[] = []

  createNewEpgSource() {
    return stores.epg.createEpgSource(this.newEpgSource)
    .then((response) => {
        this.cancel();
        this.$emit('created');
    });
  }

  cancel() {
    // @ts-ignore
    this.$children[0].close();
  }

  mounted() {
    this.types = stores.epg.providerTypes
// Fetch all the forms we want to apply custom Bootstrap validation styles to
    const forms = document.getElementsByClassName('needs-validation');
    // Loop over them and prevent submission
    const validation = Array.prototype.filter.call(forms, (form) => {
      form.addEventListener('submit', (event: any) => {
        event.preventDefault();
        if (form.checkValidity() === true) {
          event.stopPropagation();
          this.createNewEpgSource();
        }
        if (form.checkValidity() === false) {
          event.stopPropagation();
        }
        form.classList.add('was-validated');
      }, false);
    });
  }
}
